import { Button, ButtonProps } from '@fluentui/react-components';
import config from '@config/index';
import { proxyUrl } from '@shared/utils';

type TProps = ButtonProps & {
  href: string;
  mimetype: string;
  filename: string;
  openInBrowser?: boolean;
};

const DownloadButton = ({ href, mimetype, filename, openInBrowser = false, ...props }: TProps) => {
  return (
    // @ts-ignore
    <Button
      as="a"
      download={openInBrowser ? undefined : filename}
      target={openInBrowser ? '_blank' : undefined}
      href={proxyUrl(href, filename, mimetype, openInBrowser)}
      {...props}
    />
  );
};

export default DownloadButton;
